<template>
    <div>
        <el-dialog
            v-model="dialogVisible"
            title="回访录音"
            :destroy-on-close="true"
            width="600"
            top="2vh"
            @opened="opened"
            @close="close"
        >
            <div class="text" v-loading="loading">
                <div class="dialog-body-text mb20">
                    <p class="text__inline">
                        <span>校区:</span>
                        <span>{{ row.schoolName }}</span>
                    </p>
                    <p class="text__inline">
                        <span>回访时间:</span>
                        <span>{{ row.returnVisitDate }}</span>
                    </p>
                    <p class="text__inline">
                        <span>学员姓名:</span>
                        <span>{{ row.studentName }}</span>
                    </p>
                    <p class="text__inline">
                        <span>咨询老师:</span>
                        <span>{{ row.teacherName }}</span>
                    </p>
                    <p class="text__inline">
                        <span>通话时间:</span>
                        <span>{{ row.returnVisitDate }}</span>
                    </p>
                     <p class="text__inline">
                        <span>通话时长:</span>
                        <span>{{ row.fileTime }}</span>
                    </p>
                </div>
                <div ref="visualizerRef" class="cav" style="width: 100%; height: 100px"></div>
                <header>
                    <span>通话录音：</span>
                    <p>
                        <audio
                            ref="audioRef"
                            controls
                            crossOrigin="anonymous"
                            @play="onPlay"
                            @pause="onPause"
                            @ended="onEnded"
                        >
                            <source :src="fileUrl" type="audio/mpeg" />
                            <source :src="fileUrl" type="audio/flac" />
                            <source :src="fileUrl" type="audio/aiff" />
                            <source :src="fileUrl" type="audio/m4a" />
                            您的浏览器不支持 audio 元素。
                        </audio>
                    </p>
                </header>
                <ul class="ul" v-if="list.length">
                    <li v-for="(item, index) in list" :key="index">
                        <span class="user">{{ item.user }}：</span>
                        <span class="word">{{ item.message }}</span>
                    </li>
                </ul>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible = false">
                        关闭
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { addLook } from '@/api/sell-center';
import { getVisitRecordText,getRecordText } from '@/api/Tccc/index'
const dialogVisible = defineModel("show", {
    default: false,
    required: true,
});
const audioRef = ref(null)
const visualizerRef = ref(null)
const props = defineProps({
    id: {
        type: String,
        default: "",
    },
    fileUrl: {
        type: String,
        default: "",
    },
    recordId:{
        type: String,
        default: "",
    },
    row:{
        type:Object,
        default:()=>({})
    }
});
const emits = defineEmits(['refresh']);
const timeout = ref(null)
const list = ref([])
const loading = ref(false)
const getList = async ()=>{
    if(!props.recordId){
        return
    }
    try {
        loading.value = true;
        const { data } = await getRecordText(props.recordId);
        list.value = data || [];
        loading.value = false;
    } catch (error) {
        loading.value = false;
    }
}
const opened = () => {
    getList()
};
function close(){
    if (timeout.value) clearInterval(timeout.value);
    timeout.value = null;
    audioRef.value.currentTime = 0;
    audioRef.value.pause()
    list.value = [];
    emits('refresh')
}

const onPlay = () => {
    console.log('音频开始播放');
    if(props.id&&!timeout.value){
        addLook({ id: props.id, isFirst: '是' }).then(() => {
            handleLook();
        });
    }
    visualize()
};
//轮询打点
function handleLook() {
  timeout.value = setInterval(() => {
    addLook({ id: props.id }).catch(() => {
      if (timeout.value) clearInterval(timeout.value);
    });
  }, 5 * 1000);
}
const onPause = () => {
  console.log('音频已暂停');
};

const onEnded = () => {
  console.log('音频播放结束');
};
//音频可视化
function visualize() {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const source = audioContext.createMediaElementSource(audioRef.value);
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = 256;

  source.connect(analyser);
  analyser.connect(audioContext.destination);

  const bufferLength = analyser.frequencyBinCount;
  const dataArray = new Uint8Array(bufferLength);

  const canvas = document.createElement('canvas');
  const canvasCtx = canvas.getContext('2d');
  canvas.width = getComputedStyle(visualizerRef.value).getPropertyValue('width').replace('px', '');
  canvas.height = 100;
  visualizerRef.value.appendChild(canvas);
  function draw() {
    requestAnimationFrame(draw);
    analyser.getByteFrequencyData(dataArray);
    canvasCtx.fillStyle = 'rgba(0, 0, 0, 0.1)';
    canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
    const barWidth = (canvas.width / bufferLength) * 2.5;
    let x = 0;

    for (let i = 0; i < bufferLength; i++) {
      const barHeight = dataArray[i] * 0.5;
      const hue = (i / bufferLength) * 360;
      canvasCtx.fillStyle = `hsl(${hue}, 100%, 50%)`;
      canvasCtx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);

      x += barWidth + 1;
    }
  }

  draw();
}
</script>

<style lang="scss" scoped>
.text {
    .dialog-body-text {
        display: inline-flex;
        flex-wrap: wrap;
        .text__inline {
            line-height: 24px;
            &:not(:last-child) {
                margin-right: 50px;
            }
            span + span {
                margin-left: 5px;
            }
        }
    }
    header {
        display: flex;
        align-items: center;
        margin-top: 10px;
    }
    .cav{
        background-color: #000;
    }
    .ul{
        padding-top: 16px;
        max-height: 640px;
        overflow: auto;
        li{
            line-height: 32px;
            display: flex;
            color:#333;
            .user{
                color:#887;
            }
            .word{
                flex:1;
            }
        }
    }
}
</style>
